import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

function PickList({ items, selected, onChange, label, testid }) {
  const [q, setQ] = useState("");
  const shown = items.filter((i) => i.label.toLowerCase().includes(q.toLowerCase()));
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  return (
    <div className="space-y-1.5" data-testid={testid}>
      <Label className="text-xs">{label} {selected.length > 0 && <span className="text-muted-foreground">({selected.length} selected)</span>}</Label>
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter…" className="h-8 text-sm" data-testid={`${testid}-filter`} />
      <div className="max-h-36 space-y-1 overflow-y-auto rounded-md border border-border p-2">
        {shown.map((i) => (
          <label key={i.id} className="flex cursor-pointer items-center gap-2 text-sm">
            <Checkbox checked={selected.includes(i.id)} onCheckedChange={() => toggle(i.id)} data-testid={`${testid}-${i.id}`} />{i.label}
          </label>
        ))}
        {shown.length === 0 && <p className="text-xs text-muted-foreground">Nothing found.</p>}
      </div>
    </div>
  );
}

export default function DiscountForm({ form, setForm, products, cats }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <div className="space-y-4">
      <div className="space-y-2"><Label>Code</Label><Input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} data-testid="discount-code" placeholder="WELCOME10" /></div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Type</Label>
          <Select value={form.type} onValueChange={(v) => setForm({ ...form, type: v })}>
            <SelectTrigger data-testid="discount-type"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="percent">Percentage (%)</SelectItem><SelectItem value="fixed">Fixed amount ($)</SelectItem></SelectContent>
          </Select>
        </div>
        <div className="space-y-2"><Label>{form.type === "percent" ? "Percent off" : "Dollars off"}</Label><Input type="number" step="0.01" min="0" value={form.value} onChange={set("value")} data-testid="discount-value" /></div>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="space-y-2"><Label className="text-xs">Minimum order ($)</Label><Input type="number" step="0.01" min="0" value={form.min_order} onChange={set("min_order")} placeholder="None" data-testid="discount-min-order" /></div>
        <div className="space-y-2"><Label className="text-xs">Expires (last day)</Label><Input type="date" value={form.expires_at || ""} onChange={set("expires_at")} data-testid="discount-expires" /></div>
        <div className="space-y-2"><Label className="text-xs">Max uses</Label><Input type="number" min="1" step="1" value={form.max_uses} onChange={set("max_uses")} placeholder="Unlimited" data-testid="discount-max-uses" /></div>
      </div>
      <p className="-mt-2 text-xs text-muted-foreground">Minimum order is checked against the products subtotal, before shipping.</p>
      <div className="rounded-lg border border-border p-3">
        <p className="mb-2 text-xs text-muted-foreground">Leave both lists empty to apply the code to every product. Otherwise it only discounts the selected products / categories.</p>
        <div className="grid gap-3 sm:grid-cols-2">
          <PickList label="Categories" testid="discount-categories" items={cats.map((c) => ({ id: c.id, label: c.name }))} selected={form.category_ids} onChange={(v) => setForm({ ...form, category_ids: v })} />
          <PickList label="Products" testid="discount-products" items={products.map((p) => ({ id: p.id, label: `${p.name}${p.size ? " " + p.size : ""}` }))} selected={form.product_ids} onChange={(v) => setForm({ ...form, product_ids: v })} />
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-6">
        <div className="flex items-center gap-2"><Switch checked={form.active} onCheckedChange={(v) => setForm({ ...form, active: v })} data-testid="discount-active" /><Label>Active</Label></div>
        <div className="flex items-center gap-2"><Switch checked={form.applies_to_shipping} onCheckedChange={(v) => setForm({ ...form, applies_to_shipping: v })} data-testid="discount-shipping" /><Label>Also discount the shipping fee</Label></div>
      </div>
    </div>
  );
}
